import React from 'react'
import './Home.css'
import './Block.css'
import { useStateValue } from '../StateProvider'
import { Link} from 'react-router-dom';
import Checkout from './Checkout'
import {cartTotal} from '../Reducer'

function Cart() {
  const [{basket}]=useStateValue();


  // const [cart, setCart] = useState([]);
  
  // const remove = (removeitem) => {
  //   cart = [...basket];
  //   setCart(
  //     cart.filter((item)=>item!==removeitem
  //     )
  //   )
  // }

  // const [cartTotal, setCartTotal] = useState(0);

  // useEffect(() => {
  //   total();
  // }, [basket]);

  // const total = () => {
  //   let totalVal = 0;
  //   for (let i = 0; i < basket.length; i++) {
  //     totalVal += basket[i].price;
  //   }
  //   setCartTotal(totalVal);
  // };

  return (
    <div>

      {basket.length === 0 ? (
          <div>
            <h2 style={{marginTop:100}}>Your Shopping Basket is Empty </h2>
            <Link style={{marginTop:50,marginBottom:50}} className="nav-link" to="/Fashion"><button id="btn">Continue Shopping</button> </Link>
          </div>
        ) :
    
        (
          <div className="cart_border">
          <h1>your Cart :</h1>
          {basket.map((item,index)=>(
            <Checkout
                key={index}
                item={item}
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                rating={item.rating}
          />
          ))}

      <hr/>
      <div className="Total">
        <div className="blank"></div>
        <div className="Subtotal">
          <h5>Subtotal            : $ {cartTotal(basket)}</h5>
          <h5>Delivery Charges    : $ 40<hr/> </h5>
          <h5><b>Total Charges    : $ {cartTotal(basket)+40} </b></h5>
        </div>
      </div>
      <div>
        <button className="btn btn-primary" style={{marginBottom:'10px',marginTop:'50px'}}>Proceed To Checkout</button>
      </div>
      
      </div>
      
    )}
    
    </div>
  )
}

export default Cart
